'use strict';
var widthScreen = $(window).width();

var contLogin,campo,emailRegex;

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.onload = cargar();
    $('.modal').modal();
    $('.sidenav').sidenav();
    $('.dropdown-trigger').dropdown({
        hover: true
    });
    $('.tabs').tabs();
    $('select').formSelect();
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

var validationEfectoHeader = 1;
var refreshIntervalId,rotateInterval,refreshIntervalId2;
$(window).scroll(function() {
    if($(window).width() > 901) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background','white','!important');
            $('.header').css('border-bottom','1px solid #ECEDEF');
            $('.header').css('height','75px','important');
            $('.header').css('line-height','75px','important');
            $('.header .brand-logo img').css('top','5%','important');
            $('.spaceador').css('height','75px','important');
            var clipRect = 200;
            if(validationEfectoHeader == 1){
                validationEfectoHeader = 2;
                refreshIntervalId = setInterval(function () {
                    if(clipRect >= 60){
                        $('.header .brand-logo img').css('clip','rect(0px,'+clipRect+'px,200px,0px)');
                        clipRect = clipRect - 4;
                    }else{
                        clipRect = 59;
                        clearInterval(refreshIntervalId);
                        var rotateImg = 0;
                        rotateInterval = setInterval(function () {
                            if( rotateImg>=360 ){
                                clearInterval(rotateInterval);
                                refreshIntervalId2 = setInterval(function () {
                                    if(clipRect >= 201){
                                        clipRect = 202;
                                        clearInterval(refreshIntervalId2);
                                    }else{
                                        $('.header .brand-logo img').css('clip','rect(0px,'+clipRect+'px,200px,0px)');
                                        clipRect = clipRect + 4;
                                    }
                                },20)
                            }else{
                                $('.header .brand-logo img').css('transform','rotateX('+rotateImg+'deg)');
                                rotateImg = rotateImg +10;
                            }
                        },20);
                    }
                },20);
            }
        }else{
            if($(document).scrollTop() >=0 && $(document).scrollTop() <=85){
                $('.header').css('background','transparent','!important');
                $('.header').css('border-bottom','none');
                $('.header').css('height','85px','important');
                $('.header').css('line-height','85px','important');
                $('.header .brand-logo img').css('top','10%','important');
                $('.spaceador').css('height','85px','important');
                $('.header .brand-logo img').css('transform','rotateX(0deg)');
                validationEfectoHeader = 1;
                $('.header .brand-logo img').css('clip','rect(0px,200px,200px,0px)');
                clearInterval(refreshIntervalId);
                clearInterval(rotateInterval);
                clearInterval(refreshIntervalId2);
            }
        }
    }
});


if($(window).width() > 901) {
    $('.sectionAbout img').css('visibility','hidden');
    $('.sectionAbout .info h1').css('visibility','hidden');
    $('.sectionAbout .info p').css('visibility','hidden');
    $('.sectionAbout .info .btn').css('visibility','hidden');
}
$('.sectionSolicitar h1').css('visibility','hidden');
$('.sectionSolicitar p').css('visibility','hidden');
$('.sectionSolicitar .btn').css('visibility','hidden');
$('.sectionServicios h1').css('visibility', 'hidden');
$('.sectionExperiencias h1').css('visibility', 'hidden');
$('.sectionAventuras h1').css('visibility', 'hidden');
$(window).scroll(function() {
    if($(window).width() > 901) {
        $('.sectionAbout').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionAbout .info h1').css('visibility', 'inherit');
                    $('.sectionAbout .info h1').addClass('animated slideInLeft');
                    $('.sectionAbout .info p').css('visibility', 'inherit');
                    $('.sectionAbout .info p').addClass('animated slideInUp');
                    $('.sectionAbout .info .btn').css('visibility','inherit');
                    $('.sectionAbout .info .btn').addClass('animated slideInUp');
                    setTimeout(function () {
                        $('.sectionAbout img').css('visibility', 'inherit');
                        $('.sectionAbout img').addClass('animated slideInUp');
                    }, 500);
                }, 200);
            }
        }, {offset: '75%'});
    }
    /*en 25% si usare el up*/
    /*$('.sectionAbout').waypoint(function(direction) {
        if (direction === 'up') {
            $('.sectionAbout .info h1').removeClass('animated slideInLeft');
            $('.sectionAbout .info p').removeClass('animated slideInUp');
            $('.sectionAbout img').removeClass('animated bounceInUp');

            $('.sectionAbout .info h1').addClass('animated slideOutDown');
            $('.sectionAbout .info p').addClass('animated slideOutDown');
            $('.sectionAbout img').addClass('animated slideOutDown');
            setTimeout(function () {
                $('.sectionAbout img').css('visibility','hidden');
                $('.sectionAbout .info h1').css('visibility','hidden');
                $('.sectionAbout .info p').css('visibility','hidden');
            },300);
        }
    },{offset: '75%'});*/

    $('.sectionSolicitar').waypoint(function(direction) {
        if (direction === 'down') {
            setTimeout(function () {
                $('.sectionSolicitar h1').css('visibility', 'inherit');
                $('.sectionSolicitar h1').addClass('animated slideInUp');
                setTimeout(function () {
                    $('.sectionSolicitar p').css('visibility', 'inherit');
                    $('.sectionSolicitar p').addClass('animated slideInUp');
                    setTimeout(function () {
                        $('.sectionSolicitar .btn').css('visibility', 'inherit');
                        $('.sectionSolicitar .btn').addClass('animated slideInUp');
                    },300);
                },300);
            },200);
        }
    },{offset: '60%'});

    $('.sectionServicios').waypoint(function(direction) {
        if (direction === 'down') {
            setTimeout(function () {
                $('.sectionServicios h1').css('visibility', 'inherit');
                $('.sectionServicios h1').addClass('animated slideInUp');
            },200);
        }
    },{offset: '50%'});

    $('.sectionExperiencias').waypoint(function(direction) {
        if (direction === 'down') {
            setTimeout(function () {
                $('.sectionExperiencias h1').css('visibility', 'inherit');
                $('.sectionExperiencias h1').addClass('animated slideInUp');
            },200);
        }
    },{offset: '50%'});

    $('.sectionAventuras').waypoint(function(direction) {
        if (direction === 'down') {
            setTimeout(function () {
                $('.sectionAventuras h1').css('visibility', 'inherit');
                $('.sectionAventuras h1').addClass('animated slideInUp');
            },200);
        }
    },{offset: '50%'});

});


var refreshId  = setInterval(function () {
    $(".sectionBannerSlider img").css('transform','scale(1)');
    clearInterval(refreshId);
},100);

/*
document.onmousemove = function(e) {
    if($(window).width() > 991) {
        var offset = 10,
            x = e.clientX,
            y = e.clientY,
            pos = x / offset,
            pos2 = y / offset,
            posL3,posT3,pos4, pos5 = 520 + (y / 100);
            posL3 = $('#img_2_solicitar').css('left');
            posT3 = $('#img_2_solicitar').css('top');
            if(x >= 620){
                posL3 = parseInt(posL3.replace("px", "")) + (pos / 100);
                posT3 = parseInt(posT3.replace("px", "")) + (pos2 / 40);
            }else{
                posL3 = parseInt(posL3.replace("px", "")) - (pos / 100);
                posT3 = parseInt(posT3.replace("px", "")) - (pos2 / 40);
            }
            console.log(x);
        //document.getElementById('mochila').style.position = 'relative';
        var element = '.sectionSolicitar';
        var response = elementVisible(element);
        if( response == true){
            document.getElementById('img_1_solicitar').style.left = pos + 'px';
            document.getElementById('img_1_solicitar').style.top = pos2 + 'px';
            document.getElementById('img_2_solicitar').style.left = posL3 + 'px';
            document.getElementById('img_2_solicitar').style.top = posT3 + 'px';
        }
    }
};
*/

var contFLotanteEfect = 1;
setInterval(function () {
    if(contFLotanteEfect == 1){
        contFLotanteEfect = 2;
        document.getElementById('img_1_solicitar').style.top = '4%';
        document.getElementById('img_2_solicitar').style.top = '-10%';
        document.getElementById('img_3_solicitar').style.top = '-13%';
        document.getElementById('img_4_solicitar').style.top = '42%';
        document.getElementById('img_5_solicitar').style.bottom = '-7%';
        document.getElementById('img_6_solicitar').style.top = '73%';
        document.getElementById('img_7_solicitar').style.top = '32%';
    }else{
        contFLotanteEfect = 1;
        document.getElementById('img_1_solicitar').style.top = '5%';
        document.getElementById('img_2_solicitar').style.top = '-9%';
        document.getElementById('img_3_solicitar').style.top = '-14%';
        document.getElementById('img_4_solicitar').style.top = '44%';
        document.getElementById('img_5_solicitar').style.bottom = '-8%';
        document.getElementById('img_6_solicitar').style.top = '72%';
        document.getElementById('img_7_solicitar').style.top = '31%';
    }
},600);


function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}

$('.newsletter').on('click',function () {
    $('#formNewsletter').submit();
});

$("#formNewsletter").on('submit', function (e) {
    e.preventDefault();
    $('#nameNews').removeClass('error');
    $('#emailNews').removeClass('error');
    $('#cellphoneNews').removeClass('error');

    contLogin = 1;
    if ( $.trim($("#nameNews").val()) == "" ) {
        contLogin = 0;
        $('#nameNews').addClass('error');
    }
    if ( $.trim($("#emailNews").val()) == "" ) {
        contLogin = 0;
        $('#emailNews').addClass('error');
    }
    if ( $.trim($("#cellphoneNews").val()) == "" ) {
        contLogin = 0;
        $('#cellphoneNews').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    campo =  $('#emailNews').val();
    if(campo == ""){
        swal({
            text: "Debe digitar un correo electrónico",
            icon: imageURL,
            button: "OK",
        });
    }

    var data = $(this).serialize();
    $.ajax({
        url: https + "newsletter",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                swal({
                    text: "Gracias por suscribirte",
                    icon: "success",
                    button: "OK!",
                });
                $("#formNewsletter")[0].reset();

            }else if($.trim(data) == "2"){
                $('#emailNews').addClass('error');
                swal({
                    text: "Este correo electrónico ya \n se encuentra registrado",
                    icon: imageURL,
                    button: "OK",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }

        }

    });

});

$('.btnFormContacto').on('click',function () {
    grecaptcha.ready(function() {
        grecaptcha.execute('6LfRdtwZAAAAAGAsZTr769WArVkDxPg3hV2MFeU7', {action: 'submit'}).then(function(token) {
            $('#formContacto').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formContacto').submit();
        });
    });
    //$('#formContacto').submit();
});

$("#formContacto").on('submit', function (e) {
    e.preventDefault();
    $('#name').removeClass('error');
    $('#email').removeClass('error');
    $('#cellphone').removeClass('error');
    $('#nameEmp').removeClass('error');
    $('#descrip').removeClass('error');

    contLogin = 1;
    if ( $.trim($("#name").val()) == "" ) {
        contLogin = 0;
        $('#name').addClass('error');
    }

    if ( $.trim($("#email").val()) == "" ) {
        contLogin = 0;
        $('#email').addClass('error');
    }

    if ( $.trim($("#cellphone").val()) == "" ) {
        contLogin = 0;
        $('#cellphone').addClass('error');
    }

    if ( $.trim($("#nameEmp").val()) == "" ) {
        contLogin = 0;
        $('#nameEmp').addClass('error');
    }

    if ( $.trim($("#descrip").val()) == "" ) {
        contLogin = 0;
        $('#descrip').addClass('error');
    }

    if(contLogin == 0)
    {
        return false;
    }

    campo  = $("#email").val();
    emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    if (emailRegex.test(campo)) {
        $('#email').removeClass('error');
    } else {
        $('#email').addClass('error');
        swal({
            text: "Debe digitar un correo electrónico valido",
            icon: imageURL,
            button: "OK",
        });
        document.getElementById("emailCon").focus();
        return false;
    }

    var data = $(this).serialize();
    $.ajax({
        url: https + "contact",
        method: "POST",
        data: data,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formContacto")[0].reset();
                swal({
                    text: "Gracias por contactarnos",
                    icon: "success",
                    button: "OK!",
                });
            }else {
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });

});

/*$('.openPortafolio').click(function () {
    var idPor = this.id;
    $.ajax({
        async:true,
        type: "POST",
        dataType: "json",
        url: https + "portafolioShow",
        data:{id:idPor,action:'portafolioShow'},
        success:function(datos){
            if($.trim(datos) == 0){
                swal({
                    text: "No se encontro portafolio",
                    icon: imageURL,
                    button: "OK!",
                });
            }else if($.isEmptyObject(datos)){
                swal({
                    text: "No se encontro portafolio",
                    icon: imageURL,
                    button: "OK!",
                });
            }else{
                $.each(datos, function(index, c) {
                    $('#modalPortafolio .img').attr('src',https + c.portafolio);
                    $('#modalPortafolio').modal('open');
                });
            }
        }
    });
});*/


// WEBPACK FOOTER //
// ./resources/assets/js/app.js